import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class SuitcaseClose extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const BOTTOM: string = 'bottom_container';
        const BOOSTERS: string = `${BOTTOM}/suitcase_boosters`;
        const SUITCASE_OPEN: string = `${BOTTOM}/suitcase_open_button`;
        const SUITCASE_CLOSE: string = `${BOTTOM}/suitcase_close_button`;
        const TICKETS: string = `${BOOSTERS}/tickets_mask/tickets_container`;
        const BTN_INFO: string = `${BOOSTERS}/button_info`;
        const INFOS: string = `${BOOSTERS}/infos`;

        const suitcaseClose: GameObject = gameObject.find(SUITCASE_CLOSE);
        const suitcaseOpen: GameObject = gameObject.find(SUITCASE_OPEN);
        const tickets: GameObject = gameObject.find(TICKETS);
        const btnInfo: GameObject = gameObject.find(BTN_INFO);
        const infos: GameObject = gameObject.find(INFOS);

        const suitcaseElement: ElementComponent = suitcaseClose.getComponent(
            ElementComponent
        );
        const ticketsElement: ElementComponent = tickets.getComponent(
            ElementComponent
        );
        const infoRenderable: Renderable = btnInfo.getComponent(Renderable);

        const fadeOutTween: Tween = this.getTween(infoRenderable);
        fadeOutTween.to({ alpha: 0 }, 100);

        for (let child of infos.children) {
            child.getComponent(Renderable).visible = false;
        }

        yield* this.startTween(fadeOutTween);

        const moveDownTween = this.getTween(ticketsElement.layout.pivot);
        ticketsElement.layout.pivot[1] = 1;
        moveDownTween.to({ 1: 0 }, 300).easing(Easing.Quadratic.In);

        yield* this.startTween(moveDownTween);

        // Swap suitcases (open -> close).
        suitcaseClose.getComponent(Renderable).visible = true;
        suitcaseOpen.getComponent(Renderable).visible = false;

        const shakeTween: Tween = this.getTween(suitcaseElement.layout.offsets);
        shakeTween
            .to({ 1: -10, 3: -10 }, 100)
            .yoyo(true)
            .repeat(1);

        yield* this.startTween(shakeTween);
    }
}
